// removed by extract-text-webpack-plugin
module.exports = {"ButtonProceedMobile":"_27aIe","ButtonProceedMobileActive":"_23twO","shockwave":"_2HJex"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Button/ButtonProceedMobile/ButtonProceedMobile.scss
// module id = 440
// module chunks = 0